
export default {
  // Hero Section
  'hero.slide1.title': 'Smart Greenhouses for a Green Future',
  'hero.slide1.subtitle': 'Dutch Technology, Iranian Quality',
  'hero.slide1.description': 'With over 15 years of experience, leading in building modern greenhouses and advanced agricultural equipment',
  'hero.slide2.title': 'Advanced Agricultural Technology',
  'hero.slide2.subtitle': 'Smart Irrigation and Climate Control Systems',
  'hero.slide2.description': 'Providing the most comprehensive technological solutions to increase productivity and quality of agricultural products',
  'hero.slide3.title': 'Trusted Partner of Iranian Farmers',
  'hero.slide3.subtitle': 'Over 50 successful projects across the country',
  'hero.slide3.description': 'From design to implementation and support, accompanying you in the path of modern and sustainable agriculture development',
  
  // Buttons
  'buttons.view_products': 'View Products',
  'buttons.request_consultation': 'Request Consultation',
  'buttons.view_projects': 'Projects',
  
  // Stats Section
  'stats.projects': 'Successful Projects',
  'stats.area': 'Square Meters Built',
  'stats.experience': 'Years of Experience',
  'stats.customers': 'Satisfied Customers',
  
  // Services Section
  'services.title': 'Our Services',
  'services.description': 'Providing the most comprehensive services in designing, building and maintaining modern greenhouses',
  'services.design.title': 'Greenhouse Design & Construction',
  'services.design.description': 'Design and construction of modern greenhouses with world-class technology and international standards',
  'services.smart.title': 'Smart Systems',
  'services.smart.description': 'Installation and setup of climate control, irrigation and smart monitoring systems',
  'services.consulting.title': 'Professional Consulting',
  'services.consulting.description': 'Providing professional consulting in modern agriculture and production optimization',
  'services.maintenance.title': 'Maintenance & Support',
  'services.maintenance.description': '24-hour maintenance, repair and support services for all equipment',
  
  // About Section
  'about.title': 'About Iran GH',
  'about.description1': 'Leading in building modern greenhouses and providing innovative agricultural solutions',
  'about.why_us.title': 'Why Iran GH?',
  'about.why_us.experience': 'Over 15 years of successful experience',
  'about.why_us.quality': 'Guaranteed product quality',
  'about.why_us.support': '24/7 expert support',
  'about.why_us.projects': 'Over 50 successful projects',
  'about.why_us.description': 'Based on experience and technical knowledge, we provide the best greenhouse solutions for you.',
  'about.expertise.title': 'Our Expertise',
  'about.expertise.smart_design': 'Smart greenhouse design',
  'about.expertise.climate_control': 'Climate control systems',
  'about.expertise.irrigation': 'Advanced irrigation equipment',
  'about.expertise.consulting': 'Professional agricultural consulting',
  'about.expertise.description': 'Our expert team provides innovative solutions using the latest technologies.',
  'about.partnership.title': 'International Partnership',
  'about.partnership.dutch_tech': 'Advanced Dutch technology',
  'about.partnership.vander_hoeven': 'Partnership with Vander Hoeven',
  'about.partnership.european_standards': 'European standards',
  'about.partnership.global_quality': 'Global quality assurance',
  'about.partnership.description': 'Through international partnerships, we provide you with the best technologies in the world.',
  'about.cta.title': 'Ready to Work with You',
  'about.cta.description': 'From free consultation to complete project implementation, we will be with you at all stages',
  'about.cta.learn_more': 'Learn More About Us',
  'about.cta.contact': 'Contact Us',
  
  // Partners Section
  'partners.title': 'Our Partners',
  'partners.description': 'Cooperation with the most reputable domestic and foreign companies in greenhouse technology',
  'partners.international': 'International Partnerships',
  'partners.vander.name': 'Vander Hoeven',
  'partners.vander.country': 'Official Dutch Partner',
  'partners.vander.years': '10+ years of cooperation',
  'partners.vander.tech': 'Advanced Dutch technology',
  'partners.vander.description': 'Official Dutch partner with over 10 years of successful cooperation',
  'partners.chehelsotoon.name': 'Chehelsotoon',
  'partners.chehelsotoon.country': 'Domestic Business Partner',
  'partners.chehelsotoon.years': '8+ years of cooperation',
  'partners.chehelsotoon.quality': 'Quality local production',
  'partners.chehelsotoon.description': 'Domestic business partner with quality local production',
  'partners.benefits.title': 'Benefits of Our Partnerships',
  'partners.benefits.description': 'Why partnering with us is the right choice?',
  'partners.benefits.global_access': 'Global Access',
  'partners.benefits.global_desc': 'Connection to international markets',
  'partners.benefits.advanced_tech': 'Advanced Technology',
  'partners.benefits.tech_desc': 'Latest world technologies',
  'partners.benefits.quality_guarantee': 'Quality Guarantee',
  'partners.benefits.quality_desc': 'International quality standards',
  'partners.benefits.support': '24/7 Support',
  'partners.benefits.support_desc': 'Professional after-sales services',
  'partners.cta': 'Become Our Partner',
  
  // Testimonials Section
  'testimonials.title': 'Customer Reviews',
  'testimonials.description': 'What our customers say about the quality of our services and products',
  'testimonials.customer1.name': 'Ahmad Mohammadi',
  'testimonials.customer1.position': 'Manager of Isfahan Agricultural Complex',
  'testimonials.customer1.text': 'The construction quality and equipment of Iran GH is excellent. Our greenhouse is built with the best technology.',
  'testimonials.customer2.name': 'Fatemeh Karimi',
  'testimonials.customer2.position': 'Agricultural Expert in Mashhad',
  'testimonials.customer2.text': 'Working with Iran GH was an excellent experience. Everything was done professionally from design to implementation.',
  'testimonials.customer3.name': 'Reza Ahmadi',
  'testimonials.customer3.position': 'Greenhouse Owner in Ardabil',
  'testimonials.customer3.text': 'Dutch technology and Iranian services, an excellent combination that has led to the success of our business.',
  
  // CTA Section
  'cta.title': 'Ready to Start Your Next Project?',
  'cta.description': 'Contact our expert team and receive free consultation',
  'cta.phone': '+98 21 8844 1386',
  
  // Navigation
  'nav.read_more': 'Read More',
  'nav.view_services': 'View Services',
  'nav.view_partners': 'View Partners',
  'nav.cooperation_level': 'Cooperation Level',
  
  story: {
    badge: 'Aria Green House Company History',
    title: 'Aria Green House Success Story',
    subtitle: 'Aria Green House Company, with over 15 years of experience in designing, building, and equipping modern greenhouses, is a leader in the greenhouse industry in Iran and the Middle East region.',
    
    founding: {
      title: 'Founding of Aria Green House',
      description: 'Aria Green House was established in 2009 with the goal of providing innovative solutions in the greenhouse industry. Our company has evolved from a small engineering unit to the largest greenhouse equipment provider in the country.'
    },
    
    growth: {
      title: 'Growth and Development of Aria Green House',
      description: 'Throughout our years of operation, Aria Green House has successfully completed over 200 projects across the country and region. From small family greenhouses to large commercial complexes, all fall within our area of expertise.'
    },
    
    achievements: {
      title: 'Achievements of Aria Green House',
      description: 'Today, Aria Green House is recognized as a leader in smart greenhouse technologies and helps farmers achieve higher yields through optimal resource utilization.'
    },
    
    image_alt: 'History and achievements of Aria Green House Company',
    
    highlight: {
      title: 'Aria Green House - Pioneer in Innovation',
      description: 'With over 150,000 square meters of greenhouses built and 100+ satisfied customers'
    },
    
    timeline: {
      title: 'Aria Green House Progress Path',
      2009: {
        title: 'Beginning Operations',
        description: 'Establishment of Aria Green House with a specialized and committed team'
      },
      2015: {
        title: 'Service Expansion',
        description: 'Providing design and construction services for smart greenhouses'
      },
      2020: {
        title: 'Market Leadership',
        description: 'Becoming a leader in Iran\'s greenhouse industry'
      },
      2024: {
        title: 'Continuous Innovation',
        description: 'Introduction of advanced IoT and artificial intelligence technologies'
      }
    },
    
    milestones: {
      projects: {
        title: 'Successful Projects by Aria Green House',
        subtitle: 'Over 200 completed projects',
        description: 'Aria Green House has gained rich experience and high expertise through successful implementation of diverse projects, from small family greenhouses to large commercial complexes.',
        item1: 'Advanced hydroponic greenhouses',
        item2: 'Smart climate control systems',
        item3: 'Automatic irrigation equipment'
      },
      expansion: {
        title: 'Regional Expansion of Aria Green House',
        subtitle: 'Presence in the Middle East',
        description: 'Aria Green House has expanded its activities to neighboring countries and is recognized as a specialized reference in the Middle East region.',
        item1: 'Equipment export to neighboring countries',
        item2: 'International technical consulting and design',
        item3: 'Partnership with reputable regional companies'
      }
    },
    
    innovation: {
      title: 'Innovation at Aria Green House',
      subtitle: 'Aria Green House is always at the forefront of new technologies and provides advanced solutions through continuous research and development.',
      research: {
        title: 'Research & Development',
        description: 'Continuous investment in scientific research and development of new greenhouse technologies'
      },
      technology: {
        title: 'Smart Technology',
        description: 'Implementation of IoT systems, artificial intelligence, and advanced automation'
      },
      sustainability: {
        title: 'Environmental Sustainability',
        description: 'Focus on environmentally friendly solutions and optimal resource consumption'
      }
    }
  },

  // Hero Section
  'hero.slide1.title': 'Smart Greenhouses for a Green Future',
  'hero.slide1.subtitle': 'Dutch Technology, Iranian Quality',
  'hero.slide1.description': 'With over 15 years of experience, leading in building modern greenhouses and advanced agricultural equipment',
  'hero.slide2.title': 'Advanced Agricultural Technology',
  'hero.slide2.subtitle': 'Smart Irrigation and Climate Control Systems',
  'hero.slide2.description': 'Providing the most comprehensive technological solutions to increase productivity and quality of agricultural products',
  'hero.slide3.title': 'Trusted Partner of Iranian Farmers',
  'hero.slide3.subtitle': 'Over 50 successful projects across the country',
  'hero.slide3.description': 'From design to implementation and support, accompanying you in the path of modern and sustainable agriculture development',
  
  // Buttons
  'buttons.view_products': 'View Products',
  'buttons.request_consultation': 'Request Consultation',
  'buttons.view_projects': 'Projects',
  
  // Stats Section
  'stats.projects': 'Successful Projects',
  'stats.area': 'Square Meters Built',
  'stats.experience': 'Years of Experience',
  'stats.customers': 'Satisfied Customers',
  
  // Services Section
  'services.title': 'Our Services',
  'services.description': 'Providing the most comprehensive services in designing, building and maintaining modern greenhouses',
  'services.design.title': 'Greenhouse Design & Construction',
  'services.design.description': 'Design and construction of modern greenhouses with world-class technology and international standards',
  'services.smart.title': 'Smart Systems',
  'services.smart.description': 'Installation and setup of climate control, irrigation and smart monitoring systems',
  'services.consulting.title': 'Professional Consulting',
  'services.consulting.description': 'Providing professional consulting in modern agriculture and production optimization',
  'services.maintenance.title': 'Maintenance & Support',
  'services.maintenance.description': '24-hour maintenance, repair and support services for all equipment',
  
  // About Section
  'about.title': 'About Iran GH',
  'about.description1': 'Leading in building modern greenhouses and providing innovative agricultural solutions',
  'about.why_us.title': 'Why Iran GH?',
  'about.why_us.experience': 'Over 15 years of successful experience',
  'about.why_us.quality': 'Guaranteed product quality',
  'about.why_us.support': '24/7 expert support',
  'about.why_us.projects': 'Over 50 successful projects',
  'about.why_us.description': 'Based on experience and technical knowledge, we provide the best greenhouse solutions for you.',
  'about.expertise.title': 'Our Expertise',
  'about.expertise.smart_design': 'Smart greenhouse design',
  'about.expertise.climate_control': 'Climate control systems',
  'about.expertise.irrigation': 'Advanced irrigation equipment',
  'about.expertise.consulting': 'Professional agricultural consulting',
  'about.expertise.description': 'Our expert team provides innovative solutions using the latest technologies.',
  'about.partnership.title': 'International Partnership',
  'about.partnership.dutch_tech': 'Advanced Dutch technology',
  'about.partnership.vander_hoeven': 'Partnership with Vander Hoeven',
  'about.partnership.european_standards': 'European standards',
  'about.partnership.global_quality': 'Global quality assurance',
  'about.partnership.description': 'Through international partnerships, we provide you with the best technologies in the world.',
  'about.cta.title': 'Ready to Work with You',
  'about.cta.description': 'From free consultation to complete project implementation, we will be with you at all stages',
  'about.cta.learn_more': 'Learn More About Us',
  'about.cta.contact': 'Contact Us',
  
  // Partners Section
  'partners.title': 'Our Partners',
  'partners.description': 'Cooperation with the most reputable domestic and foreign companies in greenhouse technology',
  'partners.international': 'International Partnerships',
  'partners.vander.name': 'Vander Hoeven',
  'partners.vander.country': 'Official Dutch Partner',
  'partners.vander.years': '10+ years of cooperation',
  'partners.vander.tech': 'Advanced Dutch technology',
  'partners.vander.description': 'Official Dutch partner with over 10 years of successful cooperation',
  'partners.chehelsotoon.name': 'Chehelsotoon',
  'partners.chehelsotoon.country': 'Domestic Business Partner',
  'partners.chehelsotoon.years': '8+ years of cooperation',
  'partners.chehelsotoon.quality': 'Quality local production',
  'partners.chehelsotoon.description': 'Domestic business partner with quality local production',
  'partners.benefits.title': 'Benefits of Our Partnerships',
  'partners.benefits.description': 'Why partnering with us is the right choice?',
  'partners.benefits.global_access': 'Global Access',
  'partners.benefits.global_desc': 'Connection to international markets',
  'partners.benefits.advanced_tech': 'Advanced Technology',
  'partners.benefits.tech_desc': 'Latest world technologies',
  'partners.benefits.quality_guarantee': 'Quality Guarantee',
  'partners.benefits.quality_desc': 'International quality standards',
  'partners.benefits.support': '24/7 Support',
  'partners.benefits.support_desc': 'Professional after-sales services',
  'partners.cta': 'Become Our Partner',
  
  // Testimonials Section
  'testimonials.title': 'Customer Reviews',
  'testimonials.description': 'What our customers say about the quality of our services and products',
  'testimonials.customer1.name': 'Ahmad Mohammadi',
  'testimonials.customer1.position': 'Manager of Isfahan Agricultural Complex',
  'testimonials.customer1.text': 'The construction quality and equipment of Iran GH is excellent. Our greenhouse is built with the best technology.',
  'testimonials.customer2.name': 'Fatemeh Karimi',
  'testimonials.customer2.position': 'Agricultural Expert in Mashhad',
  'testimonials.customer2.text': 'Working with Iran GH was an excellent experience. Everything was done professionally from design to implementation.',
  'testimonials.customer3.name': 'Reza Ahmadi',
  'testimonials.customer3.position': 'Greenhouse Owner in Ardabil',
  'testimonials.customer3.text': 'Dutch technology and Iranian services, an excellent combination that has led to the success of our business.',
  
  // CTA Section
  'cta.title': 'Ready to Start Your Next Project?',
  'cta.description': 'Contact our expert team and receive free consultation',
  'cta.phone': '+98 21 8844 1386',
  
  // Navigation
  'nav.read_more': 'Read More',
  'nav.view_services': 'View Services',
  'nav.view_partners': 'View Partners',
  'nav.cooperation_level': 'Cooperation Level'
};
